<div class="evaluation-container">
    <div class="checkbox-filters sticky-top">
        <ng-container
            *ngTemplateOutlet="checkboxTemplate; context: { category: 'all', label: 'Select all', isChecked: areAllSelected(), isIndeterminate: isAllIndeterminate() }"></ng-container>
        <ng-container
            *ngTemplateOutlet="checkboxTemplate; context: { category: 'baggage', label: 'Select all Baggage stowability', isChecked: isCategorySelected('baggage'), isIndeterminate: isCategoryIndeterminate('baggage') }"></ng-container>
        <ng-container
            *ngTemplateOutlet="checkboxTemplate; context: { category: 'seats', label: 'Select all Seat availability', isChecked: isCategorySelected('seats'), isIndeterminate: isCategoryIndeterminate('seats') }"></ng-container>
        <ng-container
            *ngTemplateOutlet="checkboxTemplate; context: { category: 'timeNeed', label: 'Select all Time need for passenger change', isChecked: isCategorySelected('timeNeed'), isIndeterminate: isCategoryIndeterminate('timeNeed') }"></ng-container>
    </div>

    <div class="graphics-layout">
        <div class="left-panel">
            <div class="category">
                <h3>Baggage stowability</h3>
                <ul>
                    <li *ngFor="let graphic of groupedGraphics.baggage">
                        <ng-container *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                    </li>
                </ul>
            </div>

            <div class="category">
                <h3>Seat availability</h3>
                <ul>
                    <li *ngFor="let graphic of groupedGraphics.seats">
                        <ng-container *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                    </li>
                </ul>
            </div>
        </div>

        <div class="right-panel">
            <div class="category">
                <h3>Time need for passenger change</h3>

                <h4>a) Cumulative across all passengers</h4>

                <h5>Time need per door</h5>
                <ul>
                    <li *ngFor="let graphic of groupedGraphics.timeNeed.cumulative.perDoor">
                        <ng-container *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                    </li>
                </ul>

                <h5>Comparison of several doors of one layout</h5>
                <ul>
                    <li *ngFor="let graphic of groupedGraphics.timeNeed.cumulative.comparisonDoors">
                        <ng-container *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                    </li>
                </ul>

                <h5>Comparison of selected doors</h5>
                <ul>
                    <li *ngFor="let graphic of groupedGraphics.timeNeed.cumulative.comparisonSelectedDoors">
                        <ng-container *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                    </li>
                </ul>

                <h5>Comparison of one door each with different travel mixes</h5>
                <ul>
                    <li *ngFor="let graphic of groupedGraphics.timeNeed.cumulative.comparisonTravelMixes">
                        <ng-container *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                    </li>
                </ul>

                <h4>b) Total time need for all passengers</h4>
                <ul>
                    <li *ngFor="let graphic of groupedGraphics.timeNeed.total">
                        <ng-container *ngTemplateOutlet="graphicTemplate; context: { graphic: graphic }"></ng-container>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <ng-template #checkboxTemplate let-category="category" let-label="label" let-isChecked="isChecked"
        let-isIndeterminate="isIndeterminate">
        <label [class.disabled]="!hasSelectable(category)">
            <mat-checkbox (change)="selectAll($event.checked, category)" [disabled]="!hasSelectable(category)"
                [checked]="isChecked" [indeterminate]="isIndeterminate">
                {{ label }}
            </mat-checkbox>
        </label>
    </ng-template>

    <ng-template #graphicTemplate let-graphic="graphic">
        <label [class.disabled]="!isSelectable(graphic)">
            <mat-checkbox [disabled]="!isSelectable(graphic)" [checked]="isSelected(graphic.graphicId)"
                (change)="toggleSelection(graphic.graphicId)">
                {{ context === 'layout' ? graphic.layoutName : graphic.trainName }}
            </mat-checkbox>
        </label>
        <span *ngIf="!isSelectable(graphic)" class="disabled-message">{{ getDisabledReason(graphic) }}</span>
    </ng-template>
</div>
